<script setup>
// ============================================================================
// BonBoZ: MOT NUT DUY NHAT bat/tat bot cho tung hoi thoai, tren dau hoi thoai.
//
// Bat  -> bot nhan tin va tra loi khach trong hoi thoai nay, khung soan tin
//         KHOA lai (van ghi chu noi bo duoc).
// Tat  -> bot im, hoi thoai ve tay nguoi truc.
//
// GOP TU HAI NUT (13/09/2026, user chot). Truoc day phai bam HAI nut moi xong:
//
//     BotTestToggle       ghi custom_attributes.bot_test  -> mo cong KHEP_KIN
//     ComposerBotHandback bo gan + status=pending         -> mo ONLY_PENDING
//                                                            va SKIP_IF_ASSIGNED
//
// Bot chi noi khi CA BA cong cung mo (chatbot/rag/bridge/app.py), nen bam mot nut
// thi khong du, ma khong co gi bao cho nhan vien biet con thieu buoc nao. Nut cu
// thu hai da xoa han khoi ma nguon.
//
// LUU O `custom_attributes.bot_test`, KHONG dung nhan (user chot 02/09/2026).
// Ban dau dung nhan `bot-test` — chay duoc, nhung no hien mot chip tren hoi thoai,
// lan voi nhan phan loai that cua nhan vien. Day la co ky thuat, khong phai cach
// nguoi ta phan loai hoi thoai.
//
// Bridge doc `conversation.custom_attributes` co san trong MOI webhook nen doi cho
// luu khong ton them luot goi API nao.
// ============================================================================
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  conversationId: { type: [Number, String], required: true },
});

// PHAI TRUNG voi khoa ben chatbot/rag/bridge/app.py. Doi mot ben ma quen ben kia
// thi nut bam duoc, thuoc tinh ghi duoc, va bot van im — khong co dau hieu hong o
// dau ca.
const KHOA = 'bot_test';

const store = useStore();
const { t } = useI18n();

const dangDoi = ref(false);

const hoiThoai = computed(() => store.getters.getSelectedChat);
const thuocTinh = computed(() => hoiThoai.value?.custom_attributes || {});
const dangBat = computed(() => Boolean(thuocTinh.value[KHOA]));

const chuGoiY = computed(() =>
  dangBat.value ? t('BONBOZ.BOT_TEST.TAT') : t('BONBOZ.BOT_TEST.BAT')
);

// BA BUOC, THU TU CO CHU DICH.
//
// Bat:  bo gan TRUOC, pending SAU. Nguoc lai thi co mot khoanh khac hoi thoai da
//       pending ma nhan vien van duoc gan — khach nhan dung luc do la bot doc thay
//       assignee_type 'User' roi im luon, ma nhin trang thai lai tuong da xong.
//
// Tat:  gan lai cho chinh minh va mo hoi thoai. Hai buoc nay la DAI PHONG: du co
//       ghi hut, hai cong kia cung da dong, bot chac chan im.
const doiTrangThai = async () => {
  const id = props.conversationId;
  if (!id || dangDoi.value) return;
  dangDoi.value = true;

  // CHUP TRANG THAI CU TRUOC KHI GHI. `dangBat` la computed doc tu store, nen sau
  // khi ghi xong no da doi theo — so voi chinh no thi luon bang nhau, tuc GHI CANG
  // THANH CONG THI CANG BAO LOI. Dinh that 02/09/2026.
  const truoc = dangBat.value;
  const bat = !truoc;

  try {
    // MERGE, KHONG GHI DE. API custom_attributes cua Chatwoot thay ca cum
    // (conversations_controller.rb:133) chu khong merge nhu ben contact — gui
    // thieu la xoa nham du lieu cua nguoi khac. Panel CRM va dau quang cao
    // (fb_ad_id, ad_title) deu nam trong chinh cum nay.
    //
    // TAT THI GHI `false`, KHONG XOA KHOA. Mutation cua store merge chu khong thay
    // ca cum, nen xoa khoa thi may chu xoa that ma store van giu `true` — nut ket o
    // trang thai bat va bao loi. Ben bridge doc bang `bool(...)` nen `false` va
    // vang mat la mot.
    await store.dispatch('updateCustomAttributes', {
      conversationId: id,
      customAttributes: { ...thuocTinh.value, [KHOA]: bat },
    });

    if (bat) {
      if (hoiThoai.value?.meta?.assignee) {
        await store.dispatch('assignAgent', {
          conversationId: id,
          agentId: null,
        });
      }
      await store.dispatch('toggleStatus', {
        conversationId: id,
        status: wootConstants.STATUS_TYPE.PENDING,
      });
    } else {
      const toi = store.getters.getCurrentUser;
      if (toi?.id) {
        await store.dispatch('assignAgent', {
          conversationId: id,
          agentId: toi.id,
        });
      }
      await store.dispatch('toggleStatus', {
        conversationId: id,
        status: wootConstants.STATUS_TYPE.OPEN,
      });
    }

    // PHAI TU KIEM LAI. `updateCustomAttributes`, `assignAgent` va `toggleStatus`
    // cua upstream deu NUOT loi (store/modules/conversations/actions.js —
    // `catch (error) { // Handle error }`), nen await xong khong chung minh duoc gi.
    // Va phai kiem DU CA BA dieu kien bridge doi, khong chi moi cai co.
    const sau = store.getters.getSelectedChat;
    const co = Boolean(sau?.custom_attributes?.[KHOA]);
    const pending = sau?.status === wootConstants.STATUS_TYPE.PENDING;
    const nguoiGiu = sau?.meta?.assignee_type === 'User';
    const xong = bat ? co && pending && !nguoiGiu : !co && !pending;
    if (!xong) throw new Error('chua du dieu kien');

    useAlert(bat ? t('BONBOZ.BOT_TEST.DA_BAT') : t('BONBOZ.BOT_TEST.DA_TAT'));
  } catch {
    useAlert(t('BONBOZ.BOT_TEST.LOI'));
  } finally {
    dangDoi.value = false;
  }
};
</script>

<template>
  <!-- Cung co, cung kieu voi nut "nguoi tham gia" ben phai no. Doi mau + doi icon
       khi bat, de nhin phat biet hoi thoai nay bot co dang tra loi hay khong.
       Nut nay KHONG bao gio tu tat: no la loi duy nhat de tra hoi thoai ve cho
       nguoi, ma khung soan tin dang bi khoa. -->
  <NextButton
    v-tooltip="chuGoiY"
    :aria-label="chuGoiY"
    sm
    ghost
    :slate="!dangBat"
    :teal="dangBat"
    :icon="dangBat ? 'i-lucide-bot' : 'i-lucide-bot-off'"
    :disabled="dangDoi"
    class="rounded-md hover:bg-n-alpha-2"
    @click="doiTrangThai"
  />
</template>
